import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=c6205fce&scoped=true&lang=pug&"
import script from "./Confirmation.vue?vue&type=script&lang=js&"
export * from "./Confirmation.vue?vue&type=script&lang=js&"
import style0 from "./Confirmation.scss?vue&type=style&index=0&id=c6205fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6205fce",
  null
  
)

export default component.exports